<template>
  <span class="d-inline-block">
    <select
      name="select-ano"
      id="select-ano"
      v-model="ano"
      @change="fetchEmendasAno"
    >
      <option v-for="option in options" :value="option" :key="`ano-${option}`">
        {{ option }}
      </option>
    </select>
  </span>
</template>

<script>
import { mapGetters, mapState } from 'vuex/dist/vuex.common.js'

export default {
  data() {
    return {
      ano: new Date().getFullYear(),
      options: []
    }
  },
  created() {
    const ano_atual = this.ano
    for (let index = 2024; index <= ano_atual; index++) {
      this.options.push(index)
    }

    if (this.ano_emenda) {
      this.ano = this.ano_emenda
    }

    if (!this.quantidadeEmendas) {
      this.fetchEmendasAno()
    }
  },
  methods: {
    fetchEmendasAno() {
      this.$store.dispatch('getEmendasAno', { ano: this.ano })
    }
  },
  computed: {
    ...mapState({
      ano_emenda: state => state.emendas_parlamentares.ano
    }),
    ...mapGetters(['quantidadeEmendas'])
  }
}
</script>

<style scoped>
#select-ano {
  border: 1px solid #468c36;
  border-radius: 5px;
  padding: 5px 10px;
  color: #468c36;
  background-color: transparent;
  transition: color 0.3s ease, border-color 0.3s ease;
  font-weight: 600;
  cursor: pointer;
}

#select-ano:hover {
  color: #a1be4d;
  border-color: #a1be4d;
}
</style>



// WEBPACK FOOTER //
// src/components/emendas/SelectAno.vue